import { createI18n } from 'vue-i18n'
import zhTW from './zh-TW.js'
import enUS from './en-US.js'

const messages = {
  'zh-TW': zhTW,
  'en-US': enUS
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zh-TW',
  fallbackLocale: 'zh-TW',
  messages
})

export default i18n